
import { defineComponent, ref } from 'vue'

const TABS = [
    { id: 'finance', label: 'Финансы' },
    { id: 'clients', label: 'Клиенты' },
    { id: 'bookings', label: 'Записи' },
] as const

const REVENUE_BARS = [
    { prev: true, height: '46%' },
    { prev: false, height: '58%' },
    { prev: true, height: '52%' },
    { prev: false, height: '69%' },
    { prev: true, height: '61%' },
    { prev: false, height: '74%' },
    { prev: true, height: '67%' },
    { prev: false, height: '83%' },
    { prev: true, height: '64%' },
    { prev: false, height: '78%' },
]

export default defineComponent({
    name: 'BusinessPulseReportPreview',
    setup() {
        const activeTab = ref<(typeof TABS)[number]['id']>('finance')

        return {
            tabs: TABS,
            revenueBars: REVENUE_BARS,
            activeTab,
        }
    },
})
